'use es6';

import { CUSTOM_WIDGET_EDITOR_OPTIONS_FETCH, CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE, CUSTOM_WIDGET_EDITOR_OPTIONS_HYDRATE, CUSTOM_WIDGET_EDITOR_OPTIONS_UPDATE_PANE, CUSTOM_WIDGET_EDITOR_OPTIONS_SET_SELECTED_FIELD, CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING, CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING_SELECTION, CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_ICON_SELECTING, CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_EDITING_GLOBAL_CONTENT, CUSTOM_WIDGET_EDITOR_OPTIONS_SET_FULL_SCREEN_EDITOR_OPEN, CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE, CUSTOM_WIDGET_EDITOR_OPTIONS_SET_LANGUAGE_EDITOR, CUSTOM_WIDGET_EDITOR_OPTIONS_SELECT_SMART_RULE } from 'DesignData/actions/ActionTypes';
import * as client from 'DesignData/api/CustomWidgetEditorOptions';
import { getOptionsToSave, getFieldGrouping } from 'DesignData/selectors/customWidgetEditorOptions';
import { getCustomWidgetBufferFieldsMap } from 'DesignData/selectors/customWidgetBuffers';
import { getPortalId, getUserId } from 'DesignData/selectors/auth';
import { addFieldToSelectedFields, isTooDeepOnGroup, fieldsAreNotSiblings } from 'DesignData/helpers/customWidgetFieldsHelper';
import { createAsyncActions } from 'DesignData/lib/actions';
export function fetch() {
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    const options = client.fetch(userId, portalId);
    dispatch({
      type: CUSTOM_WIDGET_EDITOR_OPTIONS_FETCH,
      options
    });
  };
}
export function save() {
  return (dispatch, getState) => {
    const {
      error
    } = fetch;
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    const data = getOptionsToSave(state);
    client.save(userId, portalId, data).catch(err => error && dispatch(error(err)));
  };
}
Object.assign(save, createAsyncActions('options', CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE));
/**
 * Populates option data for an editor if such data
 * hasn't already been created.
 */

export function hydrate(customWidgetId) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_HYDRATE,
    customWidgetId
  };
}
export function updatePaneOptions(customWidgetId, options) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_UPDATE_PANE,
    customWidgetId,
    options
  };
}
export function setSelectedField(customWidgetId, fieldObj) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SET_SELECTED_FIELD,
    customWidgetId,
    fieldObj
  };
}
export function toggleFieldGrouping(customWidgetId, fieldType) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING,
    customWidgetId,
    fieldType
  };
}
export function toggleFieldGroupingSelection(customWidgetId, field) {
  return (dispatch, getState) => {
    const state = getState();
    const {
      selectedFields
    } = getFieldGrouping(state, {
      customWidgetId
    });
    const fieldsMap = getCustomWidgetBufferFieldsMap(state, {
      customWidgetId
    });
    const newSelectedFields = addFieldToSelectedFields(selectedFields, field);
    dispatch({
      type: CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING_SELECTION,
      customWidgetId,
      selectedFields: newSelectedFields,
      fieldsAreNotSiblings: fieldsAreNotSiblings(fieldsMap, Object.keys(newSelectedFields)),
      isTooDeep: isTooDeepOnGroup(fieldsMap, newSelectedFields)
    });
  };
}
export function setIsSelectingIcon(customWidgetId, isSelecting) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_ICON_SELECTING,
    customWidgetId,
    isSelecting
  };
}
export function setIsEditingGlobalContent(customWidgetId, isEditingGlobalContent) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_EDITING_GLOBAL_CONTENT,
    customWidgetId,
    isEditingGlobalContent
  };
}
export function setFullScreenEditorOpen(customWidgetId, open) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SET_FULL_SCREEN_EDITOR_OPEN,
    customWidgetId,
    open
  };
}
export function saveAccordionState(customWidgetId, key, isOpen = false, fieldId) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE,
    customWidgetId,
    fieldId,
    key,
    isOpen
  };
}
export function setLanguageEditor(customWidgetId, lang) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SET_LANGUAGE_EDITOR,
    customWidgetId,
    lang
  };
}
export function selectSmartRule(customWidgetId, smartRuleId) {
  return {
    type: CUSTOM_WIDGET_EDITOR_OPTIONS_SELECT_SMART_RULE,
    customWidgetId,
    smartRuleId
  };
}